<h1 *ngIf="!hideTitle" class="title">{{ current }}</h1>
<nav class="crumbs" aria-label="Breadcrumb">
  <ol fxLayout="row" fxLayoutAlign="start center" style="list-style: none; padding: 0; margin: 0;">
    <li class="crumb home">
      <a class="link" [routerLink]="['/dashboard']" style="text-decoration: underline; cursor: pointer; color: #0a58ca;">{{dashLangText}}</a>
    </li>
    <li *ngFor="let crumb of crumbs" class="crumb" fxLayout="row" fxLayoutAlign="start center">
      <mat-icon class="chevron" aria-hidden="true">chevron_right</mat-icon>
      <span class="link">{{ crumb }}</span>
    </li>
    <li class="crumb current" fxLayout="row" fxLayoutAlign="start center">
      <mat-icon class="chevron" aria-hidden="true">chevron_right</mat-icon>
      <a class="link" [attr.href]="router.url" aria-current="page" (click)="onCurrentClick($event)">{{ current }}</a>
    </li>
  </ol>
</nav>
